<template>
  <div class="options-item" @click="handleClickItem">
    <i style="width: 30.38px;height: 30.38px;" :class="['icon', classIcon]"></i>
    <div class="title">{{ textTitle }}</div>
    <i class="icon fa-solid fa-angle-right arrow" v-show="showArrow"></i>
  </div>
</template>
<script>
export default {
  name: "OptionsItem",
  data() {
    return {};
  },
  components: {},
  updated() {},
  mounted() {},
  methods: {

    handleClickItem() {
      //alert("子層內建事件");
      this.$emit("clickItem"); // 再通知父層
    }

  },
  props: {
    //標題
    textTitle: {   
      type: String,
      default: ""
    },
    //左方圖示
    classIcon:{
      type: String,
      default: "fa-solid fa-trash"
    },
    //右方指標是否呈現
    showArrow: {   
      type: Boolean,
      default: false
    },
  },
};
</script>
